module.exports = __webpack_public_path__ + "static/media/undraw_towing_6yy4.bb6d06c2.png";